<!-- =======================================Top Card=============================================== -->
<div class="row mb-2">
  <div class="col-12">
    <h4 class="mb-2 py-1 font-header-1">User</h4>
  </div>
  <div class="col-12 ">
    <div class="card">
      <div class="card-body ">

        <div class="row">
          <div class="col-6">
            <div class="c1">
              <button type="button" class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#modal"
                (click)="UserCreateUpdate('new')" *ngIf="fp.usercreate">Add
                User</button>&nbsp;&nbsp;
            </div>

          </div>
          <div class="col-6 text-end">
            <div class="c2 ">
              <button type="button" class="btn  btn-sm" (click)="Refresh()">
                <i class="fa fa-repeat"> </i>Refresh
              </button>
            </div>
          </div>
        </div>

        <!-- =====================================Grid===================================================== -->
        <div class="row mt-2">
          <div class="col pt-2">

            <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' [allowResizing]='true'
              [allowSorting]='true' allowPaging='true' [allowFiltering]='true' (resizeStop)="onResize($event)"
              [pageSettings]='initialPage' (dataStateChange)='dataStateChange($event)'
              (actionBegin)="onActionComplete($event)" [filterSettings]='filterOptions' [showColumnChooser]='true'>
              <e-columns>

                <e-column headerText="Actions" uid="action" textAlign="center" minWidth=100
                  [showInColumnChooser]='false'>
                  <ng-template #template let-data>
                    <button class="btn btn-reset-table" data-bs-toggle="modal" ngbTooltip="Reset Password"
                      *ngIf="fp.userkeyupdate" data-bs-target="#Reset_Confirmation"
                      (click)="resetpassword(data.id);UserCreateUpdate('edit')"><i class="fa fa-key"
                        aria-hidden="true"></i></button> &nbsp;

                    <button class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#UpdateUsermodal"
                      *ngIf="fp.userupdate" (click)="UserCreateUpdate('edit');selectUserdetails(data)">
                      <i class="fa fa-edit"></i></button>
                  </ng-template>
                </e-column>
                <e-column field="name" headerText="Name" minWidth=130 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="userRole" headerText="User Role" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="statusLname" headerText="User Status" minWidth=100 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="phone1" headerText="Phone" minWidth=110 type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column field="email" minWidth=100 headerText="Email" type="string">
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>

                <!--------------------------------table header icon---------------->
                <e-column width="50" [showInColumnChooser]='false'>
                  <ng-template #headerTemplate let-data>
                    <div>
                      <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                    </div>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>





<!-- ================================Add User Model================================================ -->
<span id="OpenModal1" data-bs-target="#modal" data-bs-toggle="modal"></span>
<div class="modal fade " id="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static">

  <div class="modal-dialog User-Add-Model" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Create User</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <!-- <form [formGroup]="userForm"> -->
        <div class="row">
          <div class="col-lg-6">
            <div class="row usrLbl ms-1">
              <div>
                <b>General Info</b>
              </div>
            </div>
            <hr class="mt-0">
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Status<span class="super-script">*</span></label>
              </div>
              <div class="col-lg-8" [formGroup]="userForm">
                <select class="form-control" [(ngModel)]="User.statusLid" formControlName="Status"
                  (change)="onvalChange()">
                  <option *ngFor="let userStatusData of statusList" [value]="userStatusData.Key">
                    {{userStatusData.Value}}</option>
                </select>
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('Status').valid && userForm.get('Status').touched">
              <p>Status is required</p>
            </span>
            <div class="row mb-0">
              <div class="col-lg-4">
                <label>First Name<span class="super-script">*</span></label>
              </div>
              <div class="col-lg-8" [formGroup]="userForm">
                <input type="text" class="form-control" formControlName="FirstName" [(ngModel)]="User.firstName"
                  (change)="onvalChange()">
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('FirstName').valid && userForm.get('FirstName').touched">
              <p>FirstName is required</p>
            </span>
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Middle Name</label>
              </div>
              <div class="col-lg-8" [formGroup]="userForm">
                <input type="text" class="form-control" formControlName="MiddleName" [(ngModel)]="User.middleName"
                  (change)="onvalChange()">
              </div>
            </div>
            <div class="row mb-0">
              <div class="col-lg-4">
                <label>Last Name<span class="super-script">*</span></label>
              </div>
              <div class="col-lg-8" [formGroup]="userForm">
                <input type="text" class="form-control" formControlName="LastName" [(ngModel)]="User.lastName"
                  (change)="onvalChange()">
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('LastName').valid && userForm.get('LastName').touched">
              <p>LastName is required</p>
            </span>
            <div class="row mb-1">
              <div class="col-lg-3">

              </div>
              <div class="col-lg-9"
                *ngIf="global.globalAgencyId != '00000000-0000-0000-0000-000000000000' && global.globalAgencyId != '' && global.agencyCode== 'SUPERADMIN'">
                <div class="row float-start ms-2">

                  <div class="col-lg-6">
                    <div class="row me-3">
                      <div class="d-inline-flex">
                        <input [(ngModel)]="RoleType" (ngModelChange)="RoleTypeChange()" type="radio" id="Internal"
                          name="RoleType" value="Internal" class="mt-1 ms-1">&nbsp;
                        <label for="SuperAdminRole" class="mt-1">Internal</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row ms-2">
                      <div class="d-inline-flex">
                        <input [(ngModel)]="RoleType" (ngModelChange)="RoleTypeChange()" type="radio" id="Global"
                          name="RoleType" value="Global" class="mt-1 ms-1">&nbsp;
                        <label for="EvvRole" class="mt-1">AgencyAdmin</label>
                      </div>

                    </div>
                  </div>


                </div>
              </div>


            </div>
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Role<span class="super-script">*</span></label>
              </div>
              <div class="col-lg-8" [formGroup]="userForm">
                <ng-select [(ngModel)]="roleName" [multiple]="true" formControlName="Role" [searchable]="true"
                  [clearable]="true" (change)="onvalChange()">
                  <ng-container *ngFor="let ur of UserRole">
                    <ng-option
                      *ngIf="global.agencyCode.toUpperCase() == 'SUPERADMIN'? ur.isInternal == this.isInternalRole :  ur.isInternal == true"
                      [value]="ur.id">
                      {{ur.roleName}}
                    </ng-option>
                  </ng-container>
                </ng-select>
                <!-- <ng-select [(ngModel)]="roleName" [multiple]="true" formControlName="Role" [searchable]="true" [items]="UserRole" bindLabel="roleName" bindValue="id"
                    [clearable]="true" (change)="onvalChange()">
                  
                  </ng-select> -->
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('Role').valid && userForm.get('Role').touched">
              <p>Role is required</p>
            </span>


            <div class="row mb-0">
              <div class="col-lg-4">
                <label>Location</label>
              </div>
              <div class="col-lg-8" [formGroup]="userForm">
                <ng-select [(ngModel)]="User.locId" formControlName="Location" [multiple]="true" [searchable]="true"
                  [items]="locationList" bindLabel="Value" bindValue="Key" [clearable]="true">

                </ng-select>

              </div>
            </div>








            <!-- <div class="row mb-1">
                <div class="col-lg-4">
                  <label>Location</label>
                </div>
                <div class="col-lg-8">
                  <ng-select [(ngModel)]="userLocation" [multiple]="true" formControlName="Location"
                  [searchable]="true" [items]="locationList" bindLabel="Value" bindValue="Key"
                    [clearable]="true" >
                    
                  </ng-select>
                 
                </div>
              </div>
              <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('Location').valid && userForm.get('Location').touched">
              <p>Location is required</p>
            </span> 



            <!-- <div class="row mb-1">
              <div class="col-lg-4">
                <label>FMS Employee</label>
              </div>
              <div class="col-lg-8 ms-0">
                <input type="checkbox"  formControlName="ExcludeIpRestrict"
                (change)="onvalChange()">
              </div>
            </div> -->
          </div>
          <div class="col-lg-6">
            <div class="row usrLbl ms-0">
              <div>
                <b>Contact Info</b>
              </div>
            </div>
            <hr class="mt-0">
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Email<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-8 ms-0" [formGroup]="userForm">
                <input type="text" class="form-control" formControlName="Email" [(ngModel)]="User.email"
                  (change)="onvalChange()">
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('Email').valid && userForm.get('Email').touched">
              <p>Email is required</p>
            </span>
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Phone1</label>
              </div>
              <div class="col-lg-8 ms-0" [formGroup]="userForm">
                <input type="text" min="0" max="99999999999999" (keypress)="numberOnly($event)" maxlength="14"
                  class="form-control" formControlName="Phone1" [(ngModel)]="UserPhone1"
                  (change)="DemographicPhoneFormat1();onvalChange()">
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Phone2</label>
              </div>
              <div class="col-lg-8 ms-0" [formGroup]="userForm">
                <input type="text" min="0" max="99999999999999" (keypress)="numberOnly($event)" maxlength="14"
                  class="form-control" formControlName="Phone2" [(ngModel)]="UserPhone2"
                  (change)="DemographicPhoneFormat2();onvalChange()">
              </div>
            </div>
            <div class="row usrLbl ms-0">
              <div>
                <b>Login Info</b>
              </div>
            </div>
            <hr class="mt-0">
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>User Name<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-8 ms-0" [formGroup]="userForm">
                <input type="text" class="form-control" autocomplete="off" formControlName="UserName"
                  [(ngModel)]="User.username" (change)="onvalChange()" (keypress)="isalphanumbericonly($event)">
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('UserName').valid && userForm.get('UserName').touched">
              <p>User Name is required</p>
            </span>
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Password<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-8 ms-0" [formGroup]="userForm">
                <input type="password" autocomplete="off" class="form-control" formControlName="Password"
                  [(ngModel)]="User.password" (keyup)="passvalid($event)" (change)="onvalChange()">
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('Password').valid && userForm.get('Password').touched">
              <p>Password is required</p>
            </span>
            <span class="help-block text-danger text-center" *ngIf="passerror && resetPass.get('Password').valid">
              <p>Enter valid password</p>
            </span>
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Exclude from Ip Restrict</label>
              </div>
              <div class="col-lg-8 ms-0" [formGroup]="userForm">
                <input type="checkbox" formControlName="ExcludeIpRestrict" [(ngModel)]="User.excludeIprestric"
                  (change)="onvalChange()">
              </div>
            </div>
          </div>
        </div>
        <!-- </form> -->
        <div class="row">
          <label class="ms-1 notealert"><i>Note:&nbsp;Password should contain atleast 8 characters/
              digits includes 1 special character, 1 lower and uppercase characters
            </i></label>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" [disabled]="!userForm.valid ||passerror || IsButtonDisable"
          (click)="SaveOrUpdateUser()">Save & Close</button>
        <button type="button" class="btn btn-sm" (click)="openDialog()">Close</button>
      </div>
    </div>
  </div>
</div>


<!-- =========================================Update User Model============================================= -->
<span id="OpenModal2" data-bs-target="#UpdateUsermodal" data-bs-toggle="modal"></span>
<div class="modal fade " id="UpdateUsermodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">

  <div class="modal-dialog User-Add-Model" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Update User</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <!-- <form [formGroup]="UpdateForm"> -->
        <div class="row">
          <div class="col-lg-6">
            <div class="row usrLbl ms-1">
              <div>
                <b>General Info</b>
              </div>
            </div>
            <hr class="mt-0">
            <div class="row mb-0">
              <div class="col-lg-4">
                <label>Status<span class="super-script">*</span></label>
              </div>
              <div class="col-lg-8" [formGroup]="UpdateForm">
                <select class="form-control" [(ngModel)]="User.statusLid" formControlName="StatusUpdate"
                  (change)="onvalChange()">
                  <option *ngFor="let us of statusList" [value]="us.Key">
                    {{us.Value}}</option>
                </select>
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('Status').valid && userForm.get('Status').touched">
              <p>Status is required</p>
            </span>
            <div class="row mb-0">
              <div class="col-lg-4">
                <label>First Name<span class="super-script">*</span></label>
              </div>
              <div class="col-lg-8" [formGroup]="UpdateForm">
                <input type="text" class="form-control" formControlName="FirstNameUpdate" [(ngModel)]="User.firstName"
                  (change)="onvalChange()">
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('FirstName').valid && userForm.get('FirstName').touched">
              <p>First Name is required</p>
            </span>
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Middle Name</label>
              </div>
              <div class="col-lg-8" [formGroup]="UpdateForm">
                <input type="text" class="form-control" formControlName="MiddleNameUpdate" [(ngModel)]="User.middleName"
                  (change)="onvalChange()">
              </div>
            </div>
            <div class="row mb-0">
              <div class="col-lg-4">
                <label>Last Name<span class="super-script">*</span></label>
              </div>
              <div class="col-lg-8" [formGroup]="UpdateForm">
                <input type="text" class="form-control" formControlName="LastNameUpdate" [(ngModel)]="User.lastName"
                  (change)="onvalChange()">
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('LastName').valid && userForm.get('LastName').touched">
              <p>Last Name is required</p>
            </span>

            <div class="row mb-1">
              <div class="col-lg-3">

              </div>
              <div class="col-lg-9"
                *ngIf="global.globalAgencyId != '00000000-0000-0000-0000-000000000000' && global.globalAgencyId != ''&& global.globalAgencyId != null && global.agencyCode== 'SUPERADMIN'">
                <div class="row float-start ms-2">

                  <div class="col-lg-6">
                    <div class="row me-3">
                      <div class="d-inline-flex">
                        <input [(ngModel)]="RoleTypeUpdate" (ngModelChange)="RoleTypeChangeUpdate()" type="radio"
                          id="Internal" name="RoleTypeupdate" value="Internal" class="mt-1 ms-1">&nbsp;
                        <label for="SuperAdminRole" class="mt-1">Internal</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row ms-2">
                      <div class="d-inline-flex">
                        <input [(ngModel)]="RoleTypeUpdate" (ngModelChange)="RoleTypeChangeUpdate()" type="radio"
                          id="Global" name="RoleTypeRoleTypeupdate" value="Global" class="mt-1 ms-1">&nbsp;
                        <label for="EvvRole" class="mt-1">AgencyAdmin</label>
                      </div>

                    </div>
                  </div>


                </div>
              </div>

            </div>
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Role<span class="super-script">*</span></label>
              </div>
              <div class="col-lg-8" [formGroup]="UpdateForm">

                <ng-select formControlName="RoleUpdate"
                  [disabled]="User.isAgencyAdmin && global.agencyCode.toUpperCase() != 'SUPERADMIN'"
                  [(ngModel)]="roleName" [multiple]="true" [searchable]="true" [clearable]="true"
                  (change)="onvalChange()">
                  <ng-container *ngFor="let ur of UserRole">
                    <ng-option
                      *ngIf="(global.agencyCode.toUpperCase() == 'SUPERADMIN')? (ur.isInternal == this.isInternalRole ||roleName?.includes(ur.id) ) :  (ur.isInternal == true ||roleName?.includes(ur.id))"
                      [value]="ur.id">
                      <!-- <ng-option *ngIf="roleName.includes(ur.id)" [value]="ur.id"> -->
                      {{ur.roleName}}
                    </ng-option>
                  </ng-container>
                </ng-select>

              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('Role').valid && userForm.get('Role').touched">
              <p>Role is required</p>
            </span>

            <div class="row mb-0">
              <div class="col-lg-4">
                <label>Location</label>
              </div>
              <div class="col-lg-8">
                <ng-select [multiple]="true" [searchable]="true" [(ngModel)]="User.locId" [items]="locationList"
                  bindLabel="Value" bindValue="Key" [clearable]="true">

                </ng-select>

              </div>
            </div>





          </div>
          <div class="col-lg-6">
            <div class="row usrLbl ms-0">
              <div>
                <b>Contact Info</b>
              </div>
            </div>
            <hr class="mt-0">
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Email<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-8" [formGroup]="UpdateForm">
                <input type="text" class="form-control" formControlName="EmailUpdate" [(ngModel)]="User.email"
                  (change)="onvalChange()">
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!userForm.get('Email').valid && userForm.get('Email').touched">
              <p>Email is required</p>
            </span>
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Phone1</label>
              </div>
              <div class="col-lg-8" [formGroup]="UpdateForm">
                <input type="text" min="0" max="99999999999999" (keypress)="numberOnly($event)" maxlength="14"
                  class="form-control" formControlName="Phone1Update" [(ngModel)]="UserPhone1"
                  (ngModelChange)="DemographicPhoneFormat1()" (change)="onvalChange()">
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Phone2</label>
              </div>
              <div class="col-lg-8" [formGroup]="UpdateForm">
                <input type="text" min="0" max="99999999999999" (keypress)="numberOnly($event)" maxlength="14"
                  class="form-control" formControlName="Phone2Update" [(ngModel)]="UserPhone2"
                  (ngModelChange)="DemographicPhoneFormat2()" (change)="onvalChange()">
              </div>
            </div>
            <div class="row usrLbl ms-0">
              <div>
                <b>Login Info</b>
              </div>
            </div>
            <hr class="mt-0">
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>User Name<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-8" [formGroup]="UpdateForm">
                <input type="text" class="form-control" formControlName="Username" [(ngModel)]="User.username"
                  (change)="onvalChange()" (keypress)="isalphanumbericonly($event)">
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-lg-4">
                <label>Exclude from Ip Restrict</label>
              </div>
              <div class="col-lg-8 ms-0" [formGroup]="UpdateForm">
                <input type="checkbox" class="ms-5" formControlName="ExcludeIpRestrict"
                  [(ngModel)]="User.excludeIprestric" (change)="onvalChange()">
              </div>
            </div>
          </div>
        </div>
        <!-- </form> -->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" [disabled]="!UpdateForm.valid || IsButtonDisable" (click)="SaveOrUpdateUser()">Update &
          Close</button>
        <button type="button" class="btn btn-sm" (click)="openDialog1()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- ======================Close confirmation================== -->
<span id="cancelmodal" data-bs-toggle="modal" data-bs-target="#CloseModal"></span>
<div class="modal fade primarymodal" id="CloseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        You want to close without save?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-sm" (click)="closeAddUpdateModal()">Yes</button>
        <button type="button" class="btn btn-sm btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<!-- ======================Close confirmation================== -->
<span id="cancelmodal1" data-bs-toggle="modal" data-bs-target="#CloseModal1"></span>
<div class="modal fade primarymodal" id="CloseModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        You want to close without save?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" (click)="closeAddUpdateModal1()">Yes</button>
        <button type="button" class="btn btn-sm " data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<!-- ============================Reset Password Confirmation Model========================================== -->
<span data-bs-toggle="modal" data-bs-target="#Reset_Confirmation" id="resetmodalConfirmation"></span>
<div class="modal fade " id="Reset_Confirmation" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">

  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Reset Password</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        Do you want to reset your password?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-toggle="modal"
          data-bs-target="#ResetPwdmodal">Yes</button>
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal"
          data-bs-target="#Reset_Confirmation">No</button>
      </div>
    </div>
  </div>
</div>

<!-- ============================Reset Password Model========================================== -->
<span data-bs-toggle="modal" data-bs-target="#ResetPwdmodal" id="resetmodal"></span>
<div class="modal fade " id="ResetPwdmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Password Confirmation</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="resetPass">
          <div class="row">
            <div class="col-lg-2">
              <label>Password<sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-5">
              <input type="password" class="form-control" formControlName="Password" [(ngModel)]="ResetPassword"
                (keyup)="passvalid($event)" (ngModelChange)="checkpopup('Password')">
              <span class="help-block text-danger text-center"
                *ngIf="!resetPass.get('Password').valid && resetPass.get('Password').touched">
                <p>Password is required</p>
              </span>
              <span class="help-block text-danger text-center" *ngIf="passerror && resetPass.get('Password').valid">
                <p>Enter valid password</p>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <label><i>Note:&nbsp;Password should contain atleast 8 characters/
                  digits includes 1 special character, 1 lower and uppercase characters
                </i></label>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" [disabled]="!resetPass.valid ||passerror || IsButtonDisable"
          (click)="ResetPasswrd('Success')">Save & Close</button>
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-target="#ResetPwdmodal">Close</button>
      </div>
    </div>
  </div>
</div>